<form [formGroup]="markerInfoForm" (ngSubmit)="submitForm()">
  <div class="manage-map-window">
    <div class="input-field">
      <label>{{ translations.GLOBAL.KEYS.IMAGE | translate}}</label>

      <div class="add-new-picture-field" [ngClass]="{'add-new-picture-uploaded':temporaryUploadedMarkerImage || infoImage.value}">
        <div class="add-new-picture-input-field">
          <input type="file" ng2FileSelect [uploader]="uploader" accept="image/*"
            (click)="infoImage.markAsTouched()"
            (change)="onImageSelect($event)">
        </div>
        <div class="add-new-picture-img-box">
          @if (!temporaryUploadedMarkerImage  && !infoImage.value) {
            <div class="add-new-picture-img">
              <img src="assets/images/uploadImage.png" width="100%" alt="">
            </div>
          }
          @if (temporaryUploadedMarkerImage || infoImage.value) {
            <div class="add-new-picture-img">
              <app-cdn-image-loader
                [defaultImage]="'/assets/images/wellbux-default-img/default-tracker.svg'"
                [defaultImagePanelClass]="'upload-image-height'"
                [isCdnImage]="isUploadedHeroImageCdnImage()"
                [src]="temporaryUploadedMarkerImage|| infoImage.value"
                [srcPanelClass]="'upload-image-height'"
                [height]="70"
                [width]="70">
              </app-cdn-image-loader>
            </div>
          }
        </div>
      </div>
      @if (infoImage.touched && (infoImage.errors || isUploadedMarkerImageInvalid)) {
        <div class="custom_error">
          @if (infoImage.errors && infoImage.errors.required) {
            <div>
              {{translations.GLOBAL.VALIDATION_MESSAGES.REQUIRED | translate :
              {'name': translations.GLOBAL.KEYS.IMAGE | translate}
              }}
            </div>
          }
          @if (isUploadedMarkerImageInvalid && infoImage.value) {
            <div>
              {{translations.GLOBAL.VALIDATION_MESSAGES.ALLOWED_IMAGE_TYPE | translate}}
            </div>
          }
        </div>
      }
    </div>
    <div class="input-field">
      <label>
        {{translations.MAP.MAP_INFO | translate}}:
      </label>
      <textarea [placeholder]="getTranslation(translations.MAP.MAP_INFO)"
        formControlName="mapInfo">
      </textarea>
      @if (mapInfo.touched && mapInfo.errors) {
        <div class="custom_error">
          {{getValidationErrors(mapInfo, getTranslation(translations.MAP.MAP_INFO), 25, 2)}}
        </div>
      }
    </div>
    <div class="input-field">
      <label>
        {{translations.GLOBAL.KEYS.EXTERNAL_LINK | translate}}:
      </label>
      <input type="text" [placeholder]="getTranslation(translations.GLOBAL.KEYS.EXTERNAL_LINK)"
        formControlName="mapLink"/>
        @if (mapLink.touched && mapLink.errors) {
          <div class="custom_error">
            {{
            getValidationErrors(mapLink,
            getTranslation(translations.GLOBAL.KEYS.EXTERNAL_LINK), 25, 2)
            }}
          </div>
        }
      </div>
      <div class="input__button__box">
        <button type="submit" class="orange-btn_outline">
          {{translations.GLOBAL.KEYS.SAVE_AND_CLOSE | translate}}
        </button>
        <button type="button" class="orange-btn_outline" (click)="removeMarker()">
          {{translations.MAP.REMOVE_MARKER | translate}}
        </button>
        <button type="button" class="gray-btn_outline" (click)="resetMarkerInfo()">
          {{translations.GLOBAL.KEYS.RESET | translate}}
        </button>
      </div>
    </div>
  </form>